import {EventBus, EventTypes} from '../../consts/const-event-types'

export default class Header {
  constructor(element) {
    this.el = element
    this.init()
  }

  init() {
    this.nav = this.el.querySelector('nav')



    this.setActiveLink()
  }

  setActiveLink() {
    const links = [...this.nav.querySelectorAll('.menulink')]

    links.forEach(link => {
      if(link.href === window.location.href) {
        link.classList.add('active')
      } else {
        link.classList.remove('active')
      }
    })
  }
}
